import FlatCard from "../../cards/flatcard/FlatCard";
import myLinks from "../../Object Files/links";

const ThankYou = () => {
  return (
    <div className="thank_you_main">
      <FlatCard customClass="thank-you">
        <div className="thank-you-home">
          <h1>Message received — thank you!</h1>
          <p className="thank-you-desc">
            I typically reply within 24 hours. If you do not hear back, check
            your spam folder or reach me at ucheogbonnak@gmail.com.
          </p>
          <div className="connect">
            <div className="connect-text">Connect on socials:</div>
            <div className="flex project-links-cont left__align">
              {myLinks.map((items) => (
                <a
                  key={items.id}
                  href={items.links}
                  className="project-links contact-links thankyou_link"
                  aria-label={items.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={items.icons} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="thankyou__img__cont thankyou-icon-wrap" aria-hidden="true">
          <i className="fa-solid fa-circle-check thankyou-icon"></i>
        </div>
      </FlatCard>
    </div>
  );
};

export default ThankYou;
